import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import styles from 'assets/jss/material-dashboard-pro-react/components/dropdownStyle';
import { makeStyles, PopoverOrigin } from '@material-ui/core';
import { BodyS } from 'components/Typography/Typography';
// @ts-ignore

const useStyles = makeStyles(styles);

export interface IDropdownItem {
	text: string;
	onClick: () => void;
	divider?: boolean;
	hidden?: boolean;
}

interface IDropdownProps {
	menu?: React.ReactElement | string;
	disabled?: boolean;
	items?: IDropdownItem[];
	anchorOrigin: PopoverOrigin;
	transformOrigin: PopoverOrigin;
}

const Dropdown = ({
	menu,
	disabled,
	items,
	anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
	transformOrigin = { vertical: 'top', horizontal: 'left' },
}: IDropdownProps) => {
	const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
	const classes = useStyles();

	return (
		<span>
			<div onClick={(event: React.MouseEvent<HTMLDivElement>) => !disabled && setAnchorEl(event.currentTarget)}>
				{menu}
			</div>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={anchorOrigin}
				transformOrigin={transformOrigin}
				open={Boolean(anchorEl)}
				onClose={() => setAnchorEl(null)}
				className={classes.dropdown}
			>
				{items
					?.filter(({ hidden }) => !hidden)
					.map(({ text, onClick, divider }) => (
						<MenuItem
							key={text}
							onClick={() => {
								setAnchorEl(null);
								onClick();
							}}
							divider={divider}
							classes={{ root: classes.selectMenuItem }}
						>
							<BodyS disableMargin>{text}</BodyS>
						</MenuItem>
					))}
			</Menu>
		</span>
	);
};

export default React.memo(Dropdown);
